module.exports = __webpack_public_path__ + "static/media/print.7bb4da39.svg";